var map = {
	"./btn-app-store.svg": "HEjg",
	"./btn-back-hover.svg": "EPdU",
	"./btn-back-pressed.svg": "Emby",
	"./btn-back.svg": "OhkK",
	"./btn-close-hover.svg": "BvBA",
	"./btn-close-pressed.svg": "IVqF",
	"./btn-close.svg": "o3C4",
	"./btn-delete-employee-hover.svg": "KMgH",
	"./btn-delete-employee-pressed.svg": "L8Y6",
	"./btn-delete-employee.svg": "cAWH",
	"./btn-edit-status-hover.svg": "aCg6",
	"./btn-edit-status-pressed.svg": "Lo38",
	"./btn-edit-status.svg": "95TX",
	"./btn-employee-hover.svg": "nekA",
	"./btn-employee-pressed.svg": "sjai",
	"./btn-employee.svg": "AqOq",
	"./btn-enter-hover.svg": "H6Cd",
	"./btn-enter-pressed.svg": "mzy9",
	"./btn-enter.svg": "NLIe",
	"./btn-fb.svg": "aLLF",
	"./btn-google-play.svg": "ehKn",
	"./btn-in.svg": "Guv2",
	"./btn-menu-hover.svg": "U/3z",
	"./btn-menu-pressed.svg": "tJ6q",
	"./btn-menu.svg": "YQ+F",
	"./btn-profile-hover.svg": "3uFq",
	"./btn-profile-pressed.svg": "ApMY",
	"./btn-profile.svg": "OIgO",
	"./btn-radio-button-selected-hover.svg": "fBZP",
	"./btn-radio-button-selected-pressed.svg": "uWyn",
	"./btn-radio-button-selected.svg": "u/6a",
	"./btn-radio-button-unselected-hover.svg": "nvK7",
	"./btn-radio-button-unselected-pressed.svg": "ceWH",
	"./btn-radio-button-unselected.svg": "OwKc",
	"./btn-settings-hover.svg": "bRyd",
	"./btn-settings-pressed.svg": "0YaL",
	"./btn-settings.svg": "WDRE",
	"./btn-upload-hover.svg": "mAcE",
	"./btn-upload-pressed.svg": "1NOk",
	"./btn-upload.svg": "AL2F",
	"./btn-yt.svg": "Mpet",
	"./ic-alert-red.svg": "0l3P",
	"./ic-alert.svg": "SZLR",
	"./ic-arrow-down.svg": "6b1D",
	"./ic-bct.svg": "Y5ML",
	"./ic-contact-tracer.inline.svg": "bUI/",
	"./ic-contact-tracing.svg": "bF5A",
	"./ic-download.svg": "/aes",
	"./ic-error.svg": "zp96",
	"./ic-immunity-passport.svg": "/4Ak",
	"./ic-language.svg": "yFVW",
	"./ic-logout.svg": "6lZS",
	"./ic-menu-employee-disabled.svg": "AMP9",
	"./ic-menu-employee-hover.svg": "5iTN",
	"./ic-menu-employee-pressed.svg": "ndW7",
	"./ic-menu-employee.svg": "ddEI",
	"./ic-menu-facilities-disabled.svg": "fja5",
	"./ic-menu-facilities-hover.svg": "zIZt",
	"./ic-menu-facilities-pressed.svg": "l8Al",
	"./ic-menu-facilities.svg": "1W+X",
	"./ic-menu-immunity-passport-disabled.svg": "tC0m",
	"./ic-menu-immunity-passport-hover.svg": "ZeyJ",
	"./ic-menu-immunity-passport-pressed.svg": "71xP",
	"./ic-menu-immunity-passport.svg": "Isxu",
	"./ic-menu-information-disabled.svg": "+3eo",
	"./ic-menu-information-hover.svg": "InoV",
	"./ic-menu-information-pressed.svg": "TFzs",
	"./ic-menu-information.svg": "rf9H",
	"./ic-success.svg": "et3T",
	"./ic-survey.svg": "kKVp",
	"./ic-verified-error.svg": "ay7Z",
	"./ic-warning.svg": "vqil",
	"./ic-workspace.svg": "p39n",
	"./img-employee-empty.svg": "Zrfa",
	"./img-error.svg": "1lzx",
	"./img-forgot-password.svg": "CKH2",
	"./img-login.svg": "OSko",
	"./img-no-data.svg": "pads",
	"./landing-img-a.svg": "CujX",
	"./landing-img-b.svg": "7Lde",
	"./landing-img-c.svg": "azWJ",
	"./landing-img-d.svg": "TvIG"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "OgWq";